/**
 * Shared constants for the ingestion / database tabs.
 *
 * Kept in one place so that the People form in the Database tab and the
 * concert / CD upload flows agree on the instrument vocabulary. Adding
 * a new instrument only needs to happen here.
 */

export const INSTRUMENTS = [
  'piano',
  'drums',
  'guitar',
  'trumpet',
  'bass',
  'vocals',
  'saxophone',
  'trombone',
  'percussion',
];
